import Vue from 'vue';

const mutations = {
	// ------------------------ ERRORS ------------------------
	ADD_ERROR: function(state, data) {
		console.debug('CORE|M|ADD_ERROR', typeof data.message !== 'undefined' ? data.message : data);
		var errors = state.errors.slice(0);
		errors.push(data);
		state.errors = errors;
	},

	REMOVE_ERROR: function(state, index) {
		console.debug('CORE|M|REMOVE_ERROR', index);
		Vue.delete(state.errors, index)
	},

	REMOVE_ERRORS: function(state, index) {
		console.debug('CORE|M|REMOVE_ERROR');
		state.errors = [];
	},



	// ------------------------ NOTICE ------------------------
	ADD_NOTICE: function(state, data) {
		console.debug('CORE|M|ADD_NOTICE', data);
		var notices = state.notices;
		if(!data.id) data.id = Math.random().toString(16);
		if(!data.removeAble) data.removeAble = true;
		notices.push(data);
		state.notices = notices;
	},
	REMOVE_NOTICE: function(state, id) {
		console.debug('CORE|M|REMOVE_NOTICE', id);
		state.notices = state.notices.filter(note => {
			return note.id !== id;
		});
	},



	// ------------------------ DEVMODE ------------------------
	SET_DEVMODE(state){
		console.debug('CORE|M|SET_DEVMODE');
		state.debug = true;
	},
	UNSET_DEVMODE(state){
		console.debug('CORE|M|UNSET_DEVMODE');
		state.debug = false;
	},



	// ------------------------ LOADING ------------------------
	SET_LOADING: function(state, name) {
		if(!name) console.error('START_LOADING requires a name');
		console.debug('CORE|M|START_LOADING', name);
		let loading = {}; loading[name] = true;
		state.loading = Object.assign({}, state.loading, loading);
	},
	UNSET_LOADING: function(state, name) {
		if(!name) console.error('END_LOADING requires a name');
		console.debug('CORE|M|END_LOADING', name);
		let loading = {}; loading[name] = false;
		state.loading = Object.assign({}, state.loading, loading);
	},
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/core/mutations.js